import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, FormsModule } from '@angular/forms';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment'; // adjust path if needed
import { ViewChild, ElementRef } from '@angular/core';
import { EditorModule } from '@tinymce/tinymce-angular';
@Component({
  selector: 'app-college-form-list',
  templateUrl: './college-form-list.component.html',
  styleUrls: ['./college-form-list.component.scss']
})
export class CollegeFormListComponent implements OnInit, OnDestroy {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  public tinyConfig1 = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',

    // NEW / IMPORTANT
    zindex: 50000,          // VERY high — must be higher than your modal overlay
    dialog_type: 'modal',   // ensures Tiny uses modal dialogs
    resize: true
  };


  @ViewChild('mapContainer', { static: false }) mapContainer: ElementRef;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;
  @Input() record: any = null;      // receives currentRecord from parent

  collegeId: string;  // receives collegeid from parent
  @Input() isPopup = false;
  showCourseModal = false;

  activeTab: string = 'about';
  aboutform!: FormGroup;
  locationForm!: FormGroup;
  courseForm!: FormGroup;
  amenitiesForm!: FormGroup;
  profileForm: FormGroup;
  approvalsForm: FormGroup;
  admissionplacementForm: FormGroup;
  scholarshipForm: FormGroup;
  applicationForm: FormGroup;
  collegeInfoForm: FormGroup;
  rankingForm: FormGroup;

  saving = false;
  submitted = false;
  profileSaving = false;
  savingApprovals = false;
  submittedAdmissionPlacement = false;
  SavingAdmissionPlacement = false;
  submittedScholarship = false;
  savingScholarship = false;
  submittedApplication = false;
  savingApplication = false;
  savingCollegeInfo = false;
  savingRanking = false;
  submittedRanking = false;

  universities: any[] = [];
  businessTypes = ['College', 'Institute', 'University'];
  collegeTypes = ['Private', 'Government'];
  editingCollegeId: string | null = null;
  countryList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  showMap: boolean = false;
  map: any = null;
  marker: any = null;
  autocomplete: any = null;
  placesService: any = null;
  geocoder: any = null;
  collegeAddressId: string | null = null;   // existing /collegeaddress _id
  currentLat: number | null = null;        // for map + payload
  currentLng: number | null = null;

  degree: any[] = [];
  branch: any[] = [];
  programtype: any[] = [];
  deliverymode: any[] = [];
  streams: any[] = [];
  course: any[] = [];
  courseduration: any[] = [];
  intakesession: any[] = [];
  onlineexam: any[] = [];
  currentYear = new Date().getFullYear();
  collegename: any[] = [];
  courseListRaw: any[] = [];
  deletingCourseId: string | null = null;
  courseListDisplay: any[] = [];
  editingCourseId: string | null = null;
  amenities: { id: string; label: string }[] = [];
  collegeAmenityId: string | null = null;
  existingBrochureUrl: string | null = null;
  existingLogoUrl: string | null = null;
  existingBannerUrl: string | null = null;
  selectedBrochureFile: File | null = null;
  selectedLogoFile: File | null = null;
  selectedBannerFile: File | null = null;
  selectedLogoPreview: string | null = null;
  selectedBannerPreview: string | null = null;
  otherPhotosFiles: File[] = [];          // new gallery files (this session)
  galleryExistingPhotos: any[] = [];      // photos already in DB
  approvals: any[] = [];
  collegeApprovalIds: string[] = [];
  informationId: string = '';
  rankingsList: any[] = [];      // master list from /rankings
  rankingRecordId: string = '';  // existing /collegeranking _id (for PATCH)

  private querySub: Subscription | null = null;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    // initialize form
    this.collegeId = this.route.snapshot.paramMap.get('id');
    const idFromRoute = this.route.snapshot.paramMap.get('id');
    if (idFromRoute) {
      // we are editing an existing college
      this.editingCollegeId = idFromRoute;
      this.loadCollegeForEdit(idFromRoute);
    } else {
      // creating new college (no id in route) – form stays empty
      this.editingCollegeId = null;
    }
    const params = this.route.snapshot.paramMap;

    // try multiple param names, depending on your route config
    this.collegeId =
      params.get('id') ||
      params.get('collegeId') ||
      params.get('_id') ||
      '';

    this.loadCourseDetails();
    this.allForms();
    this.allFormAPIs();
    if (this.collegeId) {
      this.loadCollegeAmenity();
    }
    console.log("Active College ID:", this.collegeId);
    // subscribe to query params to detect ?editCollege=...
    this.querySub = this.route.queryParams.subscribe(params => {
      const editId = params && params['editCollege'] ? params['editCollege'] : null;
      if (editId) {
        this.editingCollegeId = editId;
        this.activeTab = 'about';
        this.loadCollegeForEdit(editId);
      }
    });
    this.loadCollegeAddress();

    this.loadProfileData();
    if (this.collegeId) {
      this.loadCollegeThenApprovals();
    } else {
      // new college with no saved approvals yet
      this.loadApprovals();
    }
    this.AdmissionPlacementloadCollegeInfo();
    this.loadScholarship();
    this.loadApplicationDates();
    this.loadCollegeInfo();
    this.loadRanking();
  }
  allForms() {
    this.aboutform = this.fb.group({
      collegename: ['', Validators.required],
      businesstype: ['', Validators.required],
      university: ['', Validators.required],
      universityurl: [''],
      description: [''],
    });

    this.locationForm = this.fb.group({
      country: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      pincode: ['', Validators.required],
      streetaddress: ['', Validators.required],
      latitude: [''],
      longitude: ['']
    });

    this.courseForm = this.fb.group({
      degree: ['', Validators.required],
      branch: ['', Validators.required],
      programtype: ['', Validators.required],    // changed from programtype1 -> programtype
      deliverymode: ['', Validators.required],   // note camelCase as you specified
      fees: ['', Validators.required],
      streams: ['', Validators.required],
      course: ['', Validators.required],
      courseduration: ['', Validators.required],
      intakesession: ['', Validators.required], // changed from intakeseason -> intakesession
      intakeyear: ['', Validators.required],
      onlineexam: ['', Validators.required],
      college: ['', Validators.required],
      scholarship_type: [''],
      scholarship: [''],
      // free-text / rich text fields (CKEditor bound)
      eligibility: [''],
      description: ['']
    });
    this.amenitiesForm = this.fb.group({
      amenities: this.fb.array([], Validators.required),
      noofpeople: [{ value: '', disabled: true }],
      reviews: [{ value: '', disabled: true }],
      rating: [{ value: '', disabled: true }],
    });
    this.profileForm = this.fb.group({
      brochure: [''],
      collegelogo: [''],
      collegebannerphoto: ['']
    });
    this.collegeInfoForm = this.fb.group({
      description: [''],
      Facult_ratio: [''],
      average_fees: [''],
      established_date: [''],
      fb_url: [''],
      fees: [''],
      ig_url: [''],
      international_students: [''],
      ln_url: [''],
      max_fees: [''],
      men_womenRatio: [''],
      min_fees: [''],
      student_population: [''],
      whatsapp_no: [''],
      x_url: [''],
      yt_url: [''],
      scholarshipAvailable: [false]
    });
    this.approvalsForm = this.fb.group({
      approvals: this.fb.array([])
    });
    this.admissionplacementForm = this.fb.group({
      admissions: [''],
      placements: ['']
    });
    this.scholarshipForm = this.fb.group({
      scholarship: ['']                     // backend param name = "scholarship"
    });
    this.applicationForm = this.fb.group({
      application_open: [''],
      application_deadline: [''],
      registration_start: [''],
      registration_deadline: ['']
    });
    this.rankingForm = this.fb.group({
      rankings: ['', Validators.required], // select (id from /rankings)
      year: ['', Validators.required],     // backend param: year
      rank: ['', Validators.required]      // backend param: rank (score)
    });
  }

  ngOnDestroy(): void {
    if (this.querySub) {
      this.querySub.unsubscribe();
      this.querySub = null;
    }
  }

  // convenience getter
  get about() { return this.aboutform.controls; }

  // load universities safely
  allFormAPIs() {
    this.http.get<any>(`${environment.apiUrl}/university`)
      .subscribe({
        next: res => {
          if (res && res.results && Array.isArray(res.results)) {
            this.universities = res.results;
          } else {
            // fallback: maybe API returns array directly
            if (res && Array.isArray(res)) {
              this.universities = res;
            } else {
              this.universities = [];
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Failed to load universities:', err);
          this.universities = [];
        }
      });
    this.http.get<any>(`${environment.apiUrl}/country`)
      .subscribe({
        next: res => {
          if (res && res.results && Array.isArray(res.results)) {
            this.countryList = res.results;
          } else {
            // fallback: maybe API returns array directly
            if (res && Array.isArray(res)) {
              this.countryList = res;
            } else {
              this.countryList = [];
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Failed to load universities:', err);
          this.countryList = [];
        }
      });

    this.http.get<any>(`${environment.apiUrl}/state`)
      .subscribe({
        next: res => {
          if (res && res.results && Array.isArray(res.results)) {
            this.stateList = res.results;

          } else {
            // fallback: maybe API returns array directly
            if (res && Array.isArray(res)) {
              this.stateList = res;
            } else {
              this.stateList = [];
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Failed to load universities:', err);
          this.countryList = [];
        }
      });

    this.http.get<any>(`${environment.apiUrl}/city`)
      .subscribe({
        next: res => {
          if (res && res.results && Array.isArray(res.results)) {
            this.cityList = res.results;

          } else {
            // fallback: maybe API returns array directly
            if (res && Array.isArray(res)) {
              this.cityList = res;
            } else {
              this.cityList = [];
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Failed to load universities:', err);
          this.cityList = [];
        }
      });

    this.http.get<any>(`${environment.apiUrl}/streams`).subscribe({
      next: res => this.streams = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading streams:", err); this.streams = []; }
    });

    this.http.get<any>(`${environment.apiUrl}/degree`).subscribe({
      next: res => this.degree = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading degree:", err); this.degree = []; }
    });

    this.http.get<any>(`${environment.apiUrl}/course`).subscribe({
      next: res => this.course = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading course:", err); this.course = []; }
    });

    this.http.get<any>(`${environment.apiUrl}/branch`).subscribe({
      next: res => this.branch = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading branch:", err); this.branch = []; }
    });

    this.http.get<any>(`${environment.apiUrl}/courseduration`).subscribe({
      next: res => this.courseduration = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading courseduration:", err); this.courseduration = []; }
    });

    this.http.get<any>(`${environment.apiUrl}/programtype`).subscribe({
      next: res => this.programtype = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading programtype:", err); this.programtype = []; }
    });

    this.http.get<any>(`${environment.apiUrl}/intakesession`).subscribe({
      next: res => this.intakesession = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading intakesession:", err); this.intakesession = []; }
    });

    this.http.get<any>(`${environment.apiUrl}/deliverymode`).subscribe({
      next: res => this.deliverymode = (res && res.results && Array.isArray(res.results)) ? res.results : [],
      error: err => { console.error("Error loading deliveryMode:", err); this.deliverymode = []; }
    });

    // inside ngOnInit()
    this.http.get<any>(`${environment.apiUrl}/onlineexam`).subscribe({
      next: res => {
        this.onlineexam = (res && res.results && Array.isArray(res.results)) ? res.results : [];

      },
      error: err => {
        console.error("Error loading entrance exams:", err);
        this.onlineexam = [];
      }
    });

    this.http.get(`${environment.apiUrl}/amenity`)
      .subscribe(
        (res: any) => {
          var arr = [];
          if (res && res.results && res.results.length) {
            // map backend format -> { id, label }
            arr = res.results.map(function (item: any) {
              return {
                id: item.id,
                label: item.amenity
              };
            });
          }

          this.amenities = arr;
        },
        err => {
          console.error('Error loading amenities:', err);
          this.amenities = [];
        }
      );
    this.http.get<any>(environment.apiUrl + '/college/')
      .subscribe(
        (res) => {
          const colleges = res.results || [];

          const data = colleges.find((c: any) => c._id === this.collegeId);

          if (!data) {
            console.error('College with this ID not found in results:', this.collegeId);
            return;
          }

          // fill read-only fields
          this.amenitiesForm.patchValue({
            noofpeople: data.noofpeople || '',
            reviews: data.reviews || '',
            rating: data.rating || ''
          });

          // preselect amenities from backend (data.amenities is expected as array of ids)
          this.amenitiesArray.clear();
          if (data.amenities && Array.isArray(data.amenities)) {
            for (var i = 0; i < data.amenities.length; i++) {
              this.amenitiesArray.push(new FormControl(data.amenities[i]));
            }
          }

          console.log('Existing amenities for this college:', this.amenitiesArray.value);
        },
        (err) => {
          console.error('API error:', err);
        }
      );

    this.http.get<any>(`${environment.apiUrl}/approvals`)
      .subscribe({
        next: (res) => {
          this.approvals = res && res.results ? res.results : [];

          // rebuild FormArray based on approvals length
          this.approvalsArray.clear();
          this.approvals.forEach(() => {
            this.approvalsArray.push(new FormControl(false));
          });

          // OPTIONAL: if you already have saved approvals for this college,
          // you can load them and pre-check here.
          // this.preselectExistingApprovals();
        },
        error: (err) => {
          console.error('Failed to load approvals', err);
          this.approvals = [];
        }
      });

    this.http.get<any>(`${environment.apiUrl}/rankings`).subscribe({
      next: res => {
        if (res && res.results && Array.isArray(res.results)) {
          this.rankingsList = res.results;
        } else if (Array.isArray(res)) {
          this.rankingsList = res;
        } else {
          this.rankingsList = [];
        }
      },
      error: err => {
        console.error('Error loading rankings master:', err);
        this.rankingsList = [];
      }
    });
  }



  // fetch a single college for editing and patch the form
  loadCollegeForEdit(id: string) {
    this.http.get<any>(`${environment.apiUrl}/college/${id}`)
      .subscribe({
        next: res => {
          let college: any = null;

          if (res && res.result) {
            // shape: { result: { ...college } }
            college = res.result;
          } else if (res && res.results) {
            // could be { results: {..} } OR { results: [ {...} ] }
            if (Array.isArray(res.results)) {
              college = res.results[0]; // first element if it's an array
            } else {
              college = res.results;
            }
          } else {
            // maybe backend returns the object directly
            college = res;
          }

          if (!college) {
            console.warn('No college data returned for id', id, res);
            return;
          }

          // Prefill About form
          this.aboutform.patchValue({
            collegename: college.collegename || '',
            businesstype: college.businesstype || '',
            university: college.university || '',
            universityurl: college.universityurl || '',
            description: college.description || ''
          });


        },
        error: (err: HttpErrorResponse) => {
          console.error('Failed to load college for edit', err);
        }
      });
  }



  // submit - POST for create, PUT for update
  aboutsubmit() {
    this.submitted = true;
    this.aboutform.markAllAsTouched();

    if (this.saving) return;
    if (this.aboutform.invalid) return;

    this.saving = true;

    const payload: any = {
      ...this.aboutform.value,
      userid: localStorage.getItem('userId') || ''
    };

    if (!payload.userid) {
      alert('User not logged in (userid missing).');
      this.saving = false;
      return;
    }

    if (this.editingCollegeId) {
      // Update existing college
      this.http.put<any>(`${environment.apiUrl}/college/${this.editingCollegeId}`, payload)
        .subscribe({
          next: res => {
            alert('Updated successfully');
            this.saving = false;
            this.editingCollegeId = null;
            // optionally remove the editCollege query param
            this.router.navigate([], { relativeTo: this.route, queryParams: { editCollege: null }, queryParamsHandling: 'merge' });
          },
          error: (err: HttpErrorResponse) => {
            console.error('Update failed', err);
            let message = 'Unknown error';
            if (err && err.error && (err.error as any).message) {
              message = String((err.error as any).message);
            } else if (err && err.status) {
              message = 'HTTP ' + String(err.status);
            }
            alert('Update failed: ' + message);
            this.saving = false;
          }
        });
    } else {
      // Create new college
      this.http.post<any>(`${environment.apiUrl}/college`, payload)
        .subscribe({
          next: res => {
            alert('Saved successfully');
            this.aboutform.reset();
            this.submitted = false;
            this.saving = false;
          },
          error: (err: HttpErrorResponse) => {
            console.error('Save failed', err);
            let message = 'Unknown error';
            if (err && err.error && (err.error as any).message) {
              message = String((err.error as any).message);
            } else if (err && err.status) {
              message = 'HTTP ' + String(err.status);
            }
            alert('Save failed: ' + message);
            this.saving = false;
          }
        });
    }
  }

  // optional helper to programmatically start editing
  startEditById(id: string) {
    this.router.navigate([], { relativeTo: this.route, queryParams: { editCollege: id }, queryParamsHandling: 'merge' });
  }
  onTabChange(tabId: string) {
    // set active tab so template shows correct section
    this.activeTab = tabId;
  }

  //Location
  get location() { return this.locationForm.controls; }
  private findCountryIdByName(name: string): string {
    if (!name || !this.countryList || !this.countryList.length) return '';
    const lower = name.toLowerCase();
    const found = this.countryList.find((c: any) => (c.name || '').toLowerCase() === lower);
    return found ? (found.id || found._id || '') : '';
  }

  private findStateIdByName(name: string): string {
    if (!name || !this.stateList || !this.stateList.length) return '';
    const lower = name.toLowerCase();
    const found = this.stateList.find((s: any) => (s.name || '').toLowerCase() === lower);
    return found ? (found.id || found._id || '') : '';
  }

  private findCityIdByName(name: string): string {
    if (!name || !this.cityList || !this.cityList.length) return '';
    const lower = name.toLowerCase();
    const found = this.cityList.find((c: any) => (c.name || '').toLowerCase() === lower);
    return found ? (found.id || found._id || '') : '';
  }


  loadCollegeAddress(): void {
    if (!this.collegeId) {
      console.warn('No collegeId in route (loadCollegeAddress).');
      return;
    }

    const url = `${environment.apiUrl}/collegeaddress`;

    this.http.get<any>(url).subscribe({
      next: res => {
        const list = res && res.results && Array.isArray(res.results)
          ? res.results
          : (Array.isArray(res) ? res : []);

        // find record belonging to current college
        const addr = list.find((x: any) => x.college === this.collegeId);

        if (!addr) {
          console.log('No collegeaddress record for college', this.collegeId);
          this.collegeAddressId = null;
          this.currentLat = null;
          this.currentLng = null;
          return;
        }

        this.collegeAddressId = addr._id || addr.id || null;
        this.currentLat = addr.latitude || null;
        this.currentLng = addr.longitude || null;

        // patch dropdowns + fields
        this.locationForm.patchValue({
          country: addr.country || (addr.countryDetails && addr.countryDetails.id) || '',
          state: addr.state || (addr.stateDetails && addr.stateDetails.id) || '',
          city: addr.city || (addr.cityDetails && addr.cityDetails.id) || '',
          pincode: addr.pincode || '',
          streetaddress: addr.address || '',
          latitude: addr.latitude || null,
          longitude: addr.longitude || null
        });

        // center map & marker when Google Maps is ready
        setTimeout(() => {
          try {
            this.initMapAndServices();
            if (this.map && this.marker && this.currentLat != null && this.currentLng != null) {
              const pos = { lat: this.currentLat, lng: this.currentLng };
              this.map.setCenter(pos);
              this.map.setZoom(15);
              this.marker.setPosition(pos);
            }
          } catch (e) {
            console.warn('Could not center map with existing college address', e);
          }
        }, 400);
      },
      error: err => {
        console.error('Failed to load collegeaddress list', err);
      }
    });
  }

  initMapAndServices() {
    if (!(window as any).google || !(window as any).google.maps) {
      setTimeout(() => this.initMapAndServices(), 250);
      return;
    }

    const google = (window as any).google;

    if (!this.map) {
      const defaultLat = 12.9716;  // Bangalore default
      const defaultLng = 77.5946;

      this.map = new google.maps.Map(this.mapContainer.nativeElement, {
        center: new google.maps.LatLng(defaultLat, defaultLng),
        zoom: 13
      });

      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true
      });

      const self = this;
      this.marker.addListener('dragend', function () {
        const pos = self.marker.getPosition();
        self.reverseGeocodeAndFill(pos.lat(), pos.lng());
      });
    }

    if (!this.placesService) {
      this.placesService = new google.maps.places.PlacesService(this.map);
    }
    if (!this.geocoder) {
      this.geocoder = new google.maps.Geocoder();
    }

    // autocomplete on search input
    if (!this.autocomplete && this.searchInput && this.searchInput.nativeElement) {
      this.autocomplete = new google.maps.places.Autocomplete(this.searchInput.nativeElement);
      this.autocomplete.setFields(['formatted_address', 'geometry', 'address_components']);

      const self = this;
      this.autocomplete.addListener('place_changed', function () {
        const place = self.autocomplete.getPlace();
        if (!place || !place.geometry) return;

        const loc = place.geometry.location;
        if (self.map) {
          self.map.panTo(loc);
          self.map.setZoom(15);
        }
        if (self.marker) {
          self.marker.setPosition(loc);
        }
        const formatted = place.formatted_address || self.searchInput.nativeElement.value;
        self.fillAddressControls(formatted, loc.lat(), loc.lng());
      });
    }
  }


  // button handler
  useCurrentLocation() {
    // show map if hidden
    if (!this.showMap) {
      this.showMap = true;
      setTimeout(() => this.initMapAndServices(), 250);
    } else {
      this.initMapAndServices();
    }

    if (!navigator || !navigator.geolocation) {
      alert('Geolocation not supported by your browser.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        console.log('Coords from browser:', pos.coords);
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;
        const accuracy = pos.coords.accuracy; // in meters
        console.log('Accuracy (m):', accuracy);

        this.initMapAndServices();
        if (this.map) {
          this.map.setCenter({ lat, lng });
          this.map.setZoom(15);
        }
        if (this.marker) {
          this.marker.setPosition({ lat, lng });
        }

        // 🔹 This ONLY used for current location – fills all fields
        this.reverseGeocodeAndFillLocation(lat, lng);
      },
      (err) => {
        console.warn('Geolocation error', err);
        alert('Unable to get location. Please allow location access or search manually.');
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0      // don’t use cached value
      }
    );
  }


  // 🔹 Used ONLY for locationForm (current location)
  // 🔹 Used ONLY when user clicks "Use Current Location"
  // 🔹 Used ONLY when user clicks "Use Current Location"
  reverseGeocodeAndFillLocation(lat: number, lng: number) {
    if (!this.geocoder) {
      this.initMapAndServices();
      setTimeout(() => this.reverseGeocodeAndFillLocation(lat, lng), 300);
      return;
    }

    const self = this;
    const latlng = { lat: parseFloat(String(lat)), lng: parseFloat(String(lng)) };

    this.geocoder.geocode({ location: latlng }, function (results, status) {
      if (status === 'OK' && results && results[0]) {
        const result = results[0];

        const formatted = result.formatted_address || '';
        if (self.searchInput && self.searchInput.nativeElement) {
          self.searchInput.nativeElement.value = formatted;
        }

        const components = result.address_components || [];
        const parts: any = {
          country: '',
          state: '',
          city: '',
          pincode: '',
          street: ''
        };

        for (let i = 0; i < components.length; i++) {
          const c = components[i];
          const types = c.types || [];

          if (types.indexOf('country') !== -1) {
            parts.country = c.long_name;
          }
          if (types.indexOf('administrative_area_level_1') !== -1) {
            parts.state = c.long_name;
          }
          if (types.indexOf('locality') !== -1) {
            parts.city = c.long_name;
          }
          if (!parts.city && types.indexOf('sublocality') !== -1) {
            parts.city = c.long_name;
          }
          if (types.indexOf('postal_code') !== -1) {
            parts.pincode = c.long_name;
          }
          if (types.indexOf('route') !== -1 || types.indexOf('street_address') !== -1) {
            if (!parts.street) {
              parts.street = c.long_name;
            }
          }
        }

        const streetAddress = parts.street || formatted;

        // 🔹 update currentLat / currentLng
        self.currentLat = lat;
        self.currentLng = lng;

        if (self.locationForm && self.locationForm.controls) {
          self.locationForm.patchValue({
            country: self.findCountryIdByName(parts.country),
            state: self.findStateIdByName(parts.state),
            city: self.findCityIdByName(parts.city),
            pincode: parts.pincode || '',
            streetaddress: streetAddress,
            latitude: lat,
            longitude: lng
          });
        }

      } else {
        console.warn('Geocoder failed: ' + status);
        alert('Unable to decode your current location. Please search manually.');
      }
    });
  }




  /**
   * Take one Google geocode result and update:
   *  - locationForm.streetaddress
   *  - locationForm.pincode
   *  - locationForm.country (id from countryList)
   *  - locationForm.state   (id from stateList)
   *  - locationForm.city    (id from cityList)
   *  - locationForm.latitude / longitude (optional)
   */
  private applyLocationFromResult(result: any, lat: number, lng: number) {
    if (!result) return;

    const formatted = result.formatted_address || '';
    const comps = result.address_components || [];

    const findComp = (type: string) =>
      comps.find((c: any) => c.types && c.types.indexOf(type) !== -1);

    const countryComp = findComp('country');
    const stateComp = findComp('administrative_area_level_1');
    const cityComp =
      findComp('locality') ||
      findComp('administrative_area_level_2') ||
      findComp('sublocality') ||
      findComp('sublocality_level_1');
    const pinComp = findComp('postal_code');

    const countryName = countryComp ? countryComp.long_name : '';
    const stateName = stateComp ? stateComp.long_name : '';
    const cityName = cityComp ? cityComp.long_name : '';
    const pincode = pinComp ? pinComp.long_name : '';

    // map names -> IDs from your master lists
    let countryId = this.locationForm.value.country;
    let stateId = this.locationForm.value.state;
    let cityId = this.locationForm.value.city;

    if (countryName && this.countryList && this.countryList.length) {
      const c = this.countryList.find(
        (x: any) => (x.name || '').toLowerCase() === countryName.toLowerCase()
      );
      if (c) countryId = c.id || c._id || '';
    }

    if (stateName && this.stateList && this.stateList.length) {
      const s = this.stateList.find(
        (x: any) => (x.name || '').toLowerCase() === stateName.toLowerCase()
      );
      if (s) stateId = s.id || s._id || '';
    }

    if (cityName && this.cityList && this.cityList.length) {
      const ct = this.cityList.find(
        (x: any) => (x.name || '').toLowerCase() === cityName.toLowerCase()
      );
      if (ct) cityId = ct.id || ct._id || '';
    }

    this.locationForm.patchValue({
      streetaddress: formatted || this.locationForm.value.streetaddress,
      pincode: pincode || this.locationForm.value.pincode,
      country: countryId,
      state: stateId,
      city: cityId,
      latitude: lat,
      longitude: lng
    });

    // optional: show formatted address in search box too
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.value = formatted;
    }
  }


  reverseGeocodeAndFill(lat: number, lng: number) {
    if (!this.geocoder) {
      this.initMapAndServices();
      setTimeout(() => this.reverseGeocodeAndFill(lat, lng), 300);
      return;
    }

    const self = this;
    const latlng = { lat: +lat, lng: +lng };

    this.geocoder.geocode({ location: latlng }, function (results, status) {
      if (status === 'OK' && results && results[0]) {
        const formatted = results[0].formatted_address;
        if (self.searchInput && self.searchInput.nativeElement) {
          self.searchInput.nativeElement.value = formatted;
        }
        self.fillAddressControls(formatted, lat, lng);
      } else {
        console.warn('Geocoder failed: ' + status);
      }
    });
  }

  // 🔴 used by search & drag – writes ONLY streetaddress + lat/lng
  fillAddressControls(formatted: string, lat: number, lng: number) {
    try {
      this.currentLat = lat;
      this.currentLng = lng;

      if (this.locationForm && this.locationForm.get('streetaddress')) {
        this.locationForm.patchValue({
          streetaddress: formatted,
          latitude: lat,
          longitude: lng
        });
      }
    } catch (e) {
      console.warn('fillAddressControls error', e);
    }
  }


  onSearchEnter() {
    this.initMapAndServices();

    // prefer autocomplete selected place
    if (this.autocomplete) {
      const place = this.autocomplete.getPlace();
      if (place && place.geometry) {
        const loc = place.geometry.location;
        const formatted = place.formatted_address || this.searchInput.nativeElement.value;
        if (this.map) {
          this.map.panTo(loc);
          this.map.setZoom(15);
        }
        if (this.marker) {
          this.marker.setPosition(loc);
        }
        this.fillAddressControls(formatted, loc.lat(), loc.lng());
        return;
      }
    }

    const query = this.searchInput && this.searchInput.nativeElement
      ? String(this.searchInput.nativeElement.value).trim()
      : '';

    if (!query) return;

    if (!this.placesService) {
      setTimeout(() => this.onSearchEnter(), 300);
      return;
    }

    const self = this;
    const request = { query, fields: ['formatted_address', 'geometry', 'name'] };

    this.placesService.findPlaceFromQuery(request, function (results, status) {
      const gm = (window as any).google.maps;
      if (status === gm.places.PlacesServiceStatus.OK && results && results[0]) {
        const place = results[0];
        const geom = place.geometry;
        if (geom && geom.location) {
          const loc = geom.location;
          const formatted = place.formatted_address || place.name || query;
          if (self.map) {
            self.map.panTo(loc);
            self.map.setZoom(15);
          }
          if (self.marker) {
            self.marker.setPosition(loc);
          }
          self.fillAddressControls(formatted, loc.lat(), loc.lng());
          if (self.searchInput && self.searchInput.nativeElement) {
            self.searchInput.nativeElement.value = formatted;
          }
          return;
        }
      }

      // geocode fallback
      if (self.geocoder) {
        self.geocoder.geocode({ address: query }, function (gResults, gStatus) {
          if (gStatus === 'OK' && gResults && gResults[0]) {
            const formatted = gResults[0].formatted_address;
            const loc2 = gResults[0].geometry.location;
            if (self.map) {
              self.map.panTo(loc2);
              self.map.setZoom(15);
            }
            if (self.marker) {
              self.marker.setPosition(loc2);
            }
            self.fillAddressControls(formatted, loc2.lat(), loc2.lng());
            if (self.searchInput && self.searchInput.nativeElement) {
              self.searchInput.nativeElement.value = formatted;
            }
          } else {
            alert('No results found for: ' + query);
          }
        });
      } else {
        alert('No results found for: ' + query);
      }
    });
  }


  onLocationSubmit(): void {
    this.submitted = true;

    if (this.locationForm.invalid) {
      this.locationForm.markAllAsTouched();
      return;
    }

    if (!this.collegeId) {
      alert('College id not found.');
      return;
    }

    const value = this.locationForm.value;

    const payload: any = {
      college: this.collegeId,
      country: value.country,
      state: value.state,
      city: value.city,
      pincode: value.pincode,
      address: value.streetaddress,
      // use form values, fallback to currentLat/currentLng
      latitude: value.latitude || this.currentLat || null,
      longitude: value.longitude || this.currentLng || null,
    };

    const headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole'),
      }),
    };

    this.saving = true;

    // UPDATE
    if (this.collegeAddressId) {
      const url = `${environment.apiUrl}/collegeaddress/${this.collegeAddressId}`;
      this.http.patch<any>(url, payload, { headers }).subscribe({
        next: res => {
          this.saving = false;
          alert('Location updated successfully.');
        },
        error: err => {
          this.saving = false;
          console.error('Failed to update collegeaddress', err);
          alert('Update failed — see console.');
        }
      });
      return;
    }

    // CREATE (POST, not PATCH)
    const postUrl = `${environment.apiUrl}/collegeaddress`;
    this.http.post<any>(postUrl, payload, { headers }).subscribe({
      next: res => {
        this.saving = false;
        alert('Location saved successfully.');
        if (res && (res._id || res.id)) {
          this.collegeAddressId = res._id || res.id;
        }
      },
      error: err => {
        this.saving = false;
        console.error('Failed to create collegeaddress', err);
        alert('Save failed — see console.');
      }
    });
  }









  //Courses Form

  get f() {
    return this.courseForm ? this.courseForm.controls : {};
  }
  openCourseModal(row?: any) {
    this.submitted = false;

    if (!this.courseForm) this.allForms();  // make sure form exists

    if (!row) {
      // create mode
      this.editingCourseId = null;
      this.courseForm.reset();

      // 🔹 always set college to current collegeId
      if (this.collegeId) {
        this.courseForm.patchValue({ college: this.collegeId });
      }

      this.showCourseModal = true;
      return;
    }

    // edit mode
    const patch = this.mapCourseRowToForm(row);
    this.courseForm.reset();
    this.courseForm.patchValue(patch);
    this.editingCourseId = row._id || row.id || null;
    this.showCourseModal = true;
  }

  // close the modal
  closeCourseModal() {
    this.showCourseModal = false;
    this.editingCourseId = null;
    // optional: reset the form so next open is clean
    if (this.courseForm) {
      this.courseForm.reset();
    }
  }
  mapCourseRowToForm(row: any): any {
    // try to pick the ID (or nested object _id)
    const pickId = (v: any) => {
      if (!v) return '';
      if (typeof v === 'string') return v;
      if (v._id) return v._id;
      if (v.id) return v.id;
      return '';
    };

    return {
      college: pickId(row.college || row.collegeId || row.college_id || row.collegeDetails),
      streams: pickId(row.streams || row.stream || row.streamDetails),
      degree: pickId(row.degree),
      course: pickId(row.course),
      branch: pickId(row.branch),
      courseduration: pickId(row.courseduration || row.duration || row.coursedurationDetails),
      programtype: pickId(row.programtype),
      deliverymode: pickId(row.deliverymode),
      fees: (row.fees !== undefined && row.fees !== null) ? row.fees : (row.fee || row.amount || ''),
      intakesession: pickId(row.intakesession),
      intakeyear: row.intakeyear || row.intakeYear || '',
      onlineexam: pickId(row.onlineexam),
      eligibility: row.eligibility || '',
      description: row.description || ''
    };
  }
  onEditCourse(rowRaw: any) {
    if (!rowRaw) return;
    this.openCourseModal(rowRaw);
  }
  // called when the "Add" button inside modal is clicked (submit)
  onCourseFormSubmit() {
    this.submitted = true;
    if (!this.courseForm) return;

    if (this.courseForm.invalid) {
      this.courseForm.markAllAsTouched();
      return;
    }

    var payload = this.courseForm.value;

    // 🔹 ensure college is always set to this.collegeId
    if (this.collegeId) {
      payload.college = this.collegeId;
    }

    // UPDATE
    if (this.editingCourseId) {
      const url = environment.apiUrl + '/collegecoursedetails/' + this.editingCourseId;
      this.http.patch<any>(url, payload).subscribe({
        next: () => {
          alert('Course updated');
          this.closeCourseModal();
          this.loadCourseDetails();
        },
        error: (err) => {
          console.error('Failed to update course', err);
          alert('Failed to update course');
          console.log('What is editingId?', this.editingCourseId);
        }
      });
      return;
    }

    // CREATE
    this.http.post<any>(environment.apiUrl + '/collegecoursedetails', payload)
      .subscribe({
        next: () => {
          alert('Course added');
          this.closeCourseModal();
          this.loadCourseDetails();
        },
        error: (err) => {
          console.error('Failed to save course', err);
          alert('Failed to save course');
          console.log('What is editingId?', this.editingCourseId);
        }
      });
  }

  /**
 * Delete a course by its id.
 * - asks for confirmation
 * - disables interaction while request is in-flight
 * - refreshes the table after success
 */


  onDeleteCourse(courseId: string | null) {
    if (!courseId) {
      alert('Unable to determine course id to delete.');
      return;
    }

    if (!confirm('Delete this course? This action cannot be undone.')) {
      return;
    }

    // mark deleting so template can show a spinner/disable button if desired
    this.deletingCourseId = courseId;

    const url = `${environment.apiUrl}/collegecoursedetails/${courseId}`;

    this.http.delete<any>(url).subscribe({
      next: (res) => {
        // success: reload data and show a message
        alert('Course deleted.');
        this.deletingCourseId = null;
        this.loadCourseDetails();
      },
      error: (err) => {
        console.error('Delete failed', err);
        this.deletingCourseId = null;

        // helpful messages depending on status
        if (err && err.status === 404) {
          alert('Delete failed: record not found (404). It may already be removed.');
        } else if (err && err.status === 401) {
          alert('Delete failed: not authorized (401).');
        } else {
          alert('Delete failed — see console/network for details.');
        }
      }
    });
  }


  getNameFromRow(row: any, field: string, alt1?: string, alt2?: string): string {
    try {
      var candidates = [field, alt1, alt2];
      for (var i = 0; i < candidates.length; i++) {
        var k = candidates[i];
        if (!k) continue;
        var v = row[k];
        if (!v) continue;

        // if v is a string (likely an id), try details object
        if (typeof v === 'string') {
          var details = row[k + 'Details'] || row[k + 'Detail'] || row[k + 'Data'];
          if (details) {
            if (typeof details === 'object') {
              return details.name || details.duration || details.title || String(details);
            }
            return String(details);
          }
          return v; // fallback to id string
        }

        // if v is object -> return its sensible property
        if (typeof v === 'object') {
          return v.name || v.title || v.duration || v.label || JSON.stringify(v);
        }
      }
    } catch (e) {
      // ignore and fallback
    }
    return '-';
  }

  loadCourseDetails(): void {
    var url = environment.apiUrl + '/collegecoursedetails';

    this.http.get<any>(url).subscribe({
      next: (res: any) => {
        // raw result handling (same as before)
        var allRows: any[] = [];

        if (res && Array.isArray(res.results)) {
          allRows = res.results.slice();
        } else if (Array.isArray(res)) {
          allRows = res.slice();
        } else if (res && Array.isArray(res.data)) {
          allRows = res.data.slice();
        } else if (res && (res.results || res.rows || res.data)) {
          var tmp = res.results || res.rows || res.data;
          allRows = Array.isArray(tmp) ? tmp.slice() : [];
        }

        // 🔹 FILTER by current collegeId (important part)
        var filtered: any[] = [];
        for (var i = 0; i < allRows.length; i++) {
          var r = allRows[i];

          // college can be a string or object
          var rowCollegeId = '';
          if (r.college) {
            if (typeof r.college === 'string') {
              rowCollegeId = r.college;
            } else if (r.college._id) {
              rowCollegeId = r.college._id;
            } else if (r.college.id) {
              rowCollegeId = r.college.id;
            }
          }

          if (rowCollegeId === this.collegeId) {
            filtered.push(r);
          }
        }

        // store only that college's courses as raw
        this.courseListRaw = filtered;

        // build display copy
        var displayArr: any[] = [];
        for (var j = 0; j < this.courseListRaw.length; j++) {
          var row = this.courseListRaw[j];
          displayArr.push({
            _id: row._id || row.id || null,
            streamsName: this.getNameFromRow(row, 'streams', 'stream', 'streamDetails'),
            branchName: this.getNameFromRow(row, 'branch', 'branch', 'branchDetails'),
            courseName: this.getNameFromRow(row, 'course', 'course', 'courseDetails'),
            durationName: this.getNameFromRow(row, 'courseduration', 'duration', 'coursedurationDetails'),
            fees: (row.fees !== undefined && row.fees !== null) ? row.fees : (row.fee || row.amount || ''),
            raw: row
          });
        }

        this.courseListDisplay = displayArr;
      },
      error: (err: any) => {
        console.error('Failed to load course details', err);
        this.courseListRaw = [];
        this.courseListDisplay = [];
      }
    });
  }

  //Amenities
  get amenitiesArray(): FormArray {
    return this.amenitiesForm.get('amenities') as FormArray;
  }
  loadCollegeAmenity(): void {
    if (!this.collegeId) {
      console.warn('No collegeId for amenities');
      return;
    }

    const url = `${environment.apiUrl}/collegeamenity?college=${this.collegeId}`;

    this.http.get<any>(url).subscribe(
      (res) => {
        const list = res && res.results && Array.isArray(res.results)
          ? res.results
          : [];

        if (!list.length) {
          // no collegeamenity record yet
          this.collegeAmenityId = null;
          console.log('No existing amenity record for this college');
          return;
        }

        const record = list[0];

        // save this so on submit we know to PATCH instead of POST
        this.collegeAmenityId = record._id || record.id || null;

        // clear and push existing amenity IDs into FormArray
        this.amenitiesArray.clear();

        if (record.amenities && Array.isArray(record.amenities)) {
          record.amenities.forEach((amenityId: string) => {
            this.amenitiesArray.push(new FormControl(amenityId));
          });
        }

        console.log('Existing amenities for this college:', this.amenitiesArray.value);

        // if you want, you can also fill read-only fields from collegeDetails here:
        if (record.collegeDetails) {
          this.amenitiesForm.patchValue({
            noofpeople: record.collegeDetails.noofpeople || '',
            reviews: record.collegeDetails.reviews || '',
            rating: record.collegeDetails.rating || ''
          });
        }
      },
      (err) => {
        console.error('Failed to load collegeamenity record', err);
        this.collegeAmenityId = null;
      }
    );
  }


  isAmenitySelected(id: string): boolean {
    const values = this.amenitiesArray.value || [];
    return values.indexOf(id) !== -1;
  }


  onAmenityChange(event: any): void {
    var checkbox = event.target;
    var id = checkbox.value;

    if (checkbox.checked) {
      // only push if not already there
      if (this.amenitiesArray.value.indexOf(id) === -1) {
        this.amenitiesArray.push(new FormControl(id));
      }
    } else {
      for (var i = 0; i < this.amenitiesArray.controls.length; i++) {
        if (this.amenitiesArray.controls[i].value === id) {
          this.amenitiesArray.removeAt(i);
          break;
        }
      }
    }
  }

  onAmenitiesSubmit(): void {
    this.submitted = true;

    if (this.amenitiesForm.invalid) {
      alert('Please select at least one amenity before saving.');
      return;
    }

    if (!this.collegeId) {
      alert('College id not found.');
      return;
    }

    const selectedAmenities = this.amenitiesForm.value.amenities || [];

    const headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem("adminSess"),
        role: localStorage.getItem("userRole")
      })
    };

    // 👉 Decide POST or PATCH
    if (this.collegeAmenityId) {
      // ✅ UPDATE existing record – PATCH /collegeamenity/:id
      const url = `${environment.apiUrl}/collegeamenity/${this.collegeId}`;
      const payload = { amenities: selectedAmenities };

      this.http.patch<any>(url, payload, { headers }).subscribe(
        (res) => {
          alert('Amenity saved');
          alert('Saved Successfully');
          console.log('Updated amenities', res);
        },
        (err) => {
          console.error('Update amenities failed', err);
          alert('Saving amenities failed — check console.');
        }
      );

    } else {
      // ✅ CREATE new record – POST /collegeamenity
      const url = `${environment.apiUrl}/collegeamenity`;
      const payload = {
        college: this.collegeId,          // link to the college
        amenities: selectedAmenities
      };

      this.http.post<any>(url, payload, { headers }).subscribe(
        (res) => {
          alert('Amenity saved');
          alert('Saved Successfully');
          console.log('Created amenities record', res);

          // remember id so next time we PATCH instead of POST
          if (res && (res._id || res.id)) {
            this.collegeAmenityId = res._id || res.id;
          }
        },
        (err) => {
          console.error('Create amenities failed', err);
          alert('Saving amenities failed — check console.');
        }
      );
    }
  }


  //Profile Form
  loadProfileData(): void {
    this.http.get(
      environment.apiUrl + '/college/' + this.collegeId,
      {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem('adminSess'),
            role: localStorage.getItem('userRole')
          })
        }
      }
    ).subscribe(
      (res: any) => {
        let college: any = null;

        if (res && Array.isArray(res.results)) {
          college = res.results.find((c: any) => c && c._id === this.collegeId);
        } else if (res && res._id) {
          college = res;
        } else if (res && res.data && res.data._id) {
          college = res.data;
        }

        if (!college) {
          console.error('College not found in response');
          return;
        }

        // existing files
        this.existingBrochureUrl = college.brochure || null;
        this.existingLogoUrl = college.collegelogo || null;
        this.existingBannerUrl = college.collegebannerphoto || null;

        // (optional) if backend sends them with college object
        this.galleryExistingPhotos = college.collegeOtherPhotosDetails || [];

        // form values (only for display)
        this.profileForm.patchValue({
          brochure: college.brochure || '',
          collegelogo: college.collegelogo || '',
          collegebannerphoto: college.collegebannerphoto || ''
        });

        // or if you prefer separate API for gallery:
        // this.loadGalleryPhotos();
      },
      (error: HttpErrorResponse) => {
        console.error('Error loading college profile:', error);
      }
    );
  }

  // ---------- DROPZONES FOR MAIN 3 FILES ----------

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent, field: string) {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      this.handleFile(file, field);
    }
  }

  onFileSelected(event: any, field: string) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.handleFile(file, field);
    }
  }

  handleFile(file: File, field: string) {
    if (field === 'brochure') {
      this.selectedBrochureFile = file;

    } else if (field === 'collegelogo') {
      this.selectedLogoFile = file;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedLogoPreview = e.target.result;
      };
      reader.readAsDataURL(file);

    } else if (field === 'collegebannerphoto') {
      this.selectedBannerFile = file;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.selectedBannerPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }

    // store filename in form control (for display only)
    this.profileForm.get(field).setValue(file.name);
  }

  // ---------- OTHER PHOTOS (GALLERY) DROPZONE ----------

  onOtherPhotosChange(event: any): void {
    const files = event.target.files;

    if (files && files.length) {
      for (let i = 0; i < files.length; i++) {
        this.otherPhotosFiles.push(files[i]);
      }
    }
  }

  onOtherPhotosDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onOtherPhotosDragLeave(event: DragEvent): void {
    event.preventDefault();
  }

  onOtherPhotosDrop(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer && event.dataTransfer.files;

    if (files && files.length) {
      for (let i = 0; i < files.length; i++) {
        this.otherPhotosFiles.push(files[i]);
      }
    }
  }

  // optional – if you use separate GET for gallery
  loadGalleryPhotos(): void {
    this.http.get(environment.apiUrl + '/collegeOtherPhotos/' + this.collegeId)
      .subscribe(
        (res: any) => {
          this.galleryExistingPhotos = res && res.results ? res.results : [];
        },
        (err) => console.error('Failed loading gallery', err)
      );
  }

  // remove new gallery file (not yet uploaded)
  removeNewGalleryPhoto(index: number): void {
    this.otherPhotosFiles.splice(index, 1);
  }

  // remove existing gallery photo (already in DB)
  removeExistingGalleryPhoto(photo: any, index: number): void {
    if (!photo || !photo._id) { return; }
    if (!confirm('Delete this image?')) { return; }

    this.http.delete(environment.apiUrl + '/collegeOtherPhotos/' + photo._id)
      .subscribe(
        () => {
          this.galleryExistingPhotos.splice(index, 1);
        },
        err => console.error('Failed to delete gallery photo', err)
      );
  }

  // helper for preview of new gallery files
  getFilePreview(file: File): string {
    return URL.createObjectURL(file);
  }

  // ---------- REMOVE BUTTONS FOR BROCHURE / LOGO / BANNER ----------

  // existing vs new are separate; X on existing only hides it in UI
  removeExistingBrochure(): void {
    this.existingBrochureUrl = null;
  }

  removeNewBrochure(): void {
    this.selectedBrochureFile = null;
    this.profileForm.get('brochure').setValue('');
  }

  removeExistingLogo(): void {
    this.existingLogoUrl = null;
  }

  removeNewLogo(): void {
    this.selectedLogoFile = null;
    this.selectedLogoPreview = null;
    this.profileForm.get('collegelogo').setValue('');
  }

  removeExistingBanner(): void {
    this.existingBannerUrl = null;
  }

  removeNewBanner(): void {
    this.selectedBannerFile = null;
    this.selectedBannerPreview = null;
    this.profileForm.get('collegebannerphoto').setValue('');
  }

  // ---------- SAVE BUTTON HANDLER ----------

  onSubmitProfile(): void {
    if (!this.collegeId) {
      console.error('College ID missing.');
      return;
    }

    this.profileSaving = true;

    // 1) UPDATE MAIN PROFILE FILES (PUT /college/:id)
    const profileForm = new FormData();

    if (this.selectedLogoFile) {
      profileForm.append('collegelogo', this.selectedLogoFile);
    }
    if (this.selectedBannerFile) {
      profileForm.append('collegebannerphoto', this.selectedBannerFile);
    }
    if (this.selectedBrochureFile) {
      profileForm.append('brochure', this.selectedBrochureFile);
    }

    const headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole')
      })
    };

    this.http.put(
      environment.apiUrl + '/college/' + this.collegeId,
      profileForm,
      { headers: headers }
    )
      .subscribe(
        (profileRes: any) => {

          // 2) UPLOAD OTHER PHOTOS (POST /collegeOtherPhotos)
          if (this.otherPhotosFiles.length > 0) {

            const galleryForm = new FormData();
            galleryForm.append('college_id', this.collegeId);

            for (let i = 0; i < this.otherPhotosFiles.length; i++) {
              galleryForm.append('images', this.otherPhotosFiles[i]);
            }

            this.http.post(
              environment.apiUrl + '/collegeOtherPhotos',
              galleryForm,
              { headers: headers }
            )
              .subscribe(
                (galleryRes: any) => {
                  alert('Saved');
                  this.otherPhotosFiles = [];
                  this.profileSaving = false;
                  this.loadProfileData();   // refresh previews
                },
                (err2) => {
                  console.error('Gallery upload failed', err2);
                  this.profileSaving = false;
                }
              );

          } else {
            alert('Saved');
            this.profileSaving = false;
            this.loadProfileData();   // refresh previews if logo/banner/brochure changed
          }
        },
        (err1) => {
          console.error('Profile update failed', err1);
          this.profileSaving = false;
        }
      );
  }
  //College Info
  setScholarshipAvailable(value: boolean): void {
    this.collegeInfoForm.patchValue({
      scholarshipAvailable: value
    });
  }

  loadCollegeInfo() {
    if (!this.collegeId) {
      console.warn('No collegeId in route');
      return;
    }

    var headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem("adminSess"),
        role: localStorage.getItem("userRole")
      })
    };

    var self = this;

    // 🔸 Use /college/:id instead of list
    var url = environment.apiUrl + '/college/' + this.collegeId;

    this.http.get<any>(url, { headers })
      .subscribe(
        function (res) {
          // handle a few possible response shapes
          var college = null;

          if (res && res.results) {
            if (Array.isArray(res.results) && res.results.length > 0) {
              college = res.results[0];
            } else {
              college = res.results;
            }
          } else if (res && res._id) {
            college = res;
          }



          if (!college) {
            console.warn('College not found for id', self.collegeId);
            return;
          }

          // format date for <input type="date">
          var est = '';
          if (college.established_date) {
            try {
              est = new Date(college.established_date).toISOString().slice(0, 10);
            } catch (e) {
              est = '';
            }
          }

          self.collegeInfoForm.patchValue({
            description: college.description || '',
            Facult_ratio: college.Facult_ratio || '',
            average_fees: college.average_fees || '',
            established_date: est,
            fb_url: college.fb_url || '',
            fees: college.fees || '',
            ig_url: college.ig_url || '',
            international_students: college.international_students || '',
            ln_url: college.ln_url || '',
            max_fees: college.max_fees || '',
            men_womenRatio: college.men_womenRatio || '',
            min_fees: college.min_fees || '',
            student_population: college.student_population || '',
            whatsapp_no: college.whatsapp_no || '',
            x_url: college.x_url || '',
            yt_url: college.yt_url || '',
            scholarshipAvailable: Boolean(college.scholarshipAvailable)
          });
        },
        function (err) {
          console.error('Failed to load college', err);
        }
      );
  }


  onSaveCollegeInfo() {
    if (!this.collegeId) {
      alert('College id missing');
      return;
    }

    var value = this.collegeInfoForm.value;

    var payload = {
      // many backends ignore this, but it’s safe to send
      description: value.description,
      Facult_ratio: value.Facult_ratio,
      average_fees: value.average_fees,
      established_date: value.established_date,
      fb_url: value.fb_url,
      fees: value.fees,
      ig_url: value.ig_url,
      international_students: value.international_students,
      ln_url: value.ln_url,
      max_fees: value.max_fees,
      men_womenRatio: value.men_womenRatio,
      min_fees: value.min_fees,
      student_population: value.student_population,
      whatsapp_no: value.whatsapp_no,
      x_url: value.x_url,
      yt_url: value.yt_url,
      scholarshipAvailable: this.collegeInfoForm.value.scholarshipAvailable
    };

    this.savingCollegeInfo = true;

    var headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem("adminSess"),
        role: localStorage.getItem("userRole")
      })
    };

    // ❌ /college  (this gave you 404)
    // ✅ /college/:id
    var url = environment.apiUrl + '/college/' + this.collegeId;

    this.http.put<any>(url, payload, { headers })
      .subscribe(
        res => {
          this.savingCollegeInfo = false;
          alert('College successfully.');
        },
        err => {
          this.savingCollegeInfo = false;
          console.error('Failed to update college info', err);
          alert('Update failed — check console / Network tab.');
        }
      );
  }


  //Approvals
  get approvalsArray(): FormArray {
    return this.approvalsForm.get('approvals') as FormArray;
  }
  loadCollegeApprovals(): void {
    var url = environment.apiUrl + '/college/' + this.collegeId;

    this.http.get<any>(url)
      .subscribe({
        next: (res) => {
          // adjust based on your backend structure
          // examples:
          //   { result: { approvals: [...] } }
          //   { approvals: [...] }
          var college = res && res.result ? res.result : res;

          var ids: string[] = [];

          if (college && college.approvals && college.approvals.length) {
            ids = college.approvals
              .map(function (a: any) {
                if (typeof a === 'string') {
                  return a; // already an id
                }
                // if DB sends objects, try id/_id
                return a.id || a._id || '';
              })
              .filter(function (x: string) { return !!x; });
          }

          this.collegeApprovalIds = ids;

          // now load full approvals list and auto-select
          this.loadApprovals();
        },
        error: (err) => {
          console.error('Failed to load college approvals', err);
          this.collegeApprovalIds = [];
          // still load approvals list; all will be unchecked
          this.loadApprovals();
        }
      });
  }

  loadCollegeThenApprovals(): void {
    const url = `${environment.apiUrl}/college`;

    this.http.get<any>(url).subscribe({
      next: (res) => {
        const colleges = res && res.results ? res.results : [];

        // find the college that matches the current route id
        const college = colleges.find((c: any) => c._id === this.collegeId);

        if (college && Array.isArray(college.approvals)) {
          // approvals is already an array of strings:
          this.collegeApprovalIds = college.approvals;
        } else {
          this.collegeApprovalIds = [];
        }

        console.log('collegeApprovalIds:', this.collegeApprovalIds);

        // now load master approvals list & auto-check
        this.loadApprovals();
      },
      error: (err) => {
        console.error('Failed to load colleges', err);
        this.collegeApprovalIds = [];
        this.loadApprovals(); // still load approvals so user can select
      }
    });
  }


  loadApprovals(): void {
    this.http.get<any>(`${environment.apiUrl}/approvals`)
      .subscribe({
        next: (res) => {
          this.approvals = res && res.results ? res.results : [];

          this.approvalsArray.clear();

          const selectedIds = this.collegeApprovalIds; // from DB

          this.approvals.forEach((appr: any) => {
            const approvalId = appr.id || appr._id || '';
            const isChecked = selectedIds.indexOf(approvalId) !== -1;
            this.approvalsArray.push(new FormControl(isChecked));
          });
        },
        error: (err) => {
          console.error('Failed to load approvals', err);
          this.approvals = [];
          this.approvalsArray.clear();
        }
      });
  }



  onSaveApprovals(): void {
    if (!this.collegeId) {
      alert('College id not found.');
      return;
    }

    const formValue = this.approvalsForm.value; // { approvals: [true/false,...] }
    const selectedIds = this.approvals
      .filter((appr, index) => formValue.approvals[index])
      .map(appr => appr.id);

    if (!selectedIds.length) {
      if (!confirm('No approvals selected. Save empty?')) {
        return;
      }
    }

    this.savingApprovals = true;

    // ✅ UPDATE URL for that particular college
    const url = `${environment.apiUrl}/college/${this.collegeId}`;

    // ✅ Do NOT send _id in body, only the field you are updating
    const payload = {
      approvals: selectedIds
    };

    // If your backend uses PUT for update:
    this.http.put<any>(url, payload, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      }
    })
      .subscribe({
        next: (res) => {
          this.savingApprovals = false;
          alert("Approvals saved successfully.");
        },
        error: (err) => {
          console.error("Failed to save approvals", err);
          this.savingApprovals = false;

          if (err.status === 400) {
            alert("Bad request — check payload.");
          } else if (err.status === 401) {
            alert("Unauthorized.");
          } else if (err.status === 404) {
            alert("College not found.");
          } else {
            alert("Saving approvals failed — check console.");
          }
        }
      });
  }
  //Admissions and Placements
  saveAdmissionsPlacements(): void {
    this.submittedAdmissionPlacement = true;

    if (this.admissionplacementForm.invalid) {
      return;
    }

    if (!this.collegeId) {
      alert("College id not found.");
      return;
    }

    var admissions = this.admissionplacementForm.value.admissions;
    var placements = this.admissionplacementForm.value.placements;

    var self = this;
    this.SavingAdmissionPlacement = true;

    // ---------- CASE 1: UPDATE existing record via PATCH ----------
    if (this.informationId) {
      var patchUrl = environment.apiUrl + '/collegeinformations/' + this.informationId;

      var patchPayload = {
        admissions: admissions,
        placements: placements,
        college: this.collegeId
      };

      this.http.patch<any>(patchUrl, patchPayload, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        }
      }).subscribe(
        function (res) {
          self.SavingAdmissionPlacement = false;
          alert("Admissions & Placements saved successfully.");
        },
        function (err) {
          self.SavingAdmissionPlacement = false;
          console.error("Failed to update admissions/placements", err);
          alert("Update failed — see console for details.");
        }
      );

      return;
    }

    // ---------- CASE 2: CREATE new record via POST ----------
    var postUrl = environment.apiUrl + '/collegeinformations';

    var postPayload = {
      college: this.collegeId,   // link to this college
      admissions: admissions,
      placements: placements
    };

    this.http.post<any>(postUrl, postPayload, {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      }
    }).subscribe(
      function (res) {
        self.SavingAdmissionPlacement = false;
        alert("Admissions & Placements saved successfully.");

        // if backend returns created record's _id, store for future updates
        if (res && res._id) {
          self.informationId = res._id;
        }
      },
      function (err) {
        self.SavingAdmissionPlacement = false;
        console.error("Failed to save admissions/placements", err);
        alert("Save failed — see console for details.");
      }
    );
  }


  AdmissionPlacementloadCollegeInfo(): void {
    var self = this;

    this.http.get<any>(environment.apiUrl + '/college', {
      headers: {
        Userinfo: JSON.stringify({
          _id: localStorage.getItem("adminSess"),
          role: localStorage.getItem("userRole"),
        }),
      }
    }).subscribe(
      function (res) {
        var college = null;

        if (res && res.results && res.results.length > 0) {
          college = res.results.find(function (c: any) {
            return c._id === self.collegeId;
          });
        }

        if (!college) {
          console.warn("College not found for id:", self.collegeId);
          return;
        }

        // If there is existing college information, load it into the form
        if (college.collegeinformationsDetails &&
          college.collegeinformationsDetails.length > 0) {

          var info = college.collegeinformationsDetails[0];

          self.informationId = info._id;  // used later for update

          self.admissionplacementForm.patchValue({
            admissions: info.admissions || '',
            placements: info.placements || ''
          });

          console.log("Loaded admissions/placements for infoId:", self.informationId);
        } else {
          self.informationId = '';
        }
      },
      function (err) {
        console.error("Failed to load colleges", err);
      }
    );
  }
  //Ranking
  loadRanking(): void {
    if (!this.collegeId) {
      console.warn('No collegeId in route (loadRanking).');
      return;
    }

    const headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole'),
      }),
    };

    const url =
      environment.apiUrl +
      '/collegeranking?college=' +
      encodeURIComponent(this.collegeId);

    this.http.get<any>(url, { headers }).subscribe({
      next: res => {
        let rec: any = null;

        // { results: [ {...} ] }
        if (res && res.results && Array.isArray(res.results) && res.results.length) {
          rec = res.results[0];
        }
        // [ {...} ]
        else if (Array.isArray(res) && res.length) {
          rec = res[0];
        }
        // { _id: ... }
        else if (res && res._id) {
          rec = res;
        }

        if (!rec) {
          this.rankingRecordId = '';
          this.rankingForm.reset();
          return;
        }

        this.rankingRecordId = rec._id || rec.id || '';

        // rankings may be an id or an object
        const rankingsValue =
          typeof rec.rankings === 'string'
            ? rec.rankings
            : (rec.rankings && (rec.rankings._id || rec.rankings.id)) || '';

        this.rankingForm.patchValue({
          rankings: rankingsValue,
          year: rec.year || '',
          rank: rec.rank || ''
        });

        console.log('Loaded ranking record:', rec);
      },
      error: err => {
        console.error('Failed to load ranking', err);
      }
    });
  }

  onSaveRanking(): void {
    this.submittedRanking = true;

    if (this.rankingForm.invalid) {
      this.rankingForm.markAllAsTouched();
      return;
    }

    if (!this.collegeId) {
      alert('College id not found.');
      return;
    }

    const value = this.rankingForm.value;

    const payload = {
      college: this.collegeId,
      rankings: value.rankings, // id from select
      year: value.year,
      rank: value.rank
    };

    const headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole'),
      }),
    };

    this.savingRanking = true;

    // UPDATE existing record
    if (this.rankingRecordId) {
      const url = `${environment.apiUrl}/collegeranking/${this.rankingRecordId}`;

      this.http.patch<any>(url, payload, { headers }).subscribe({
        next: res => {
          this.savingRanking = false;
          alert('Ranking saved successfully.');
        },
        error: err => {
          this.savingRanking = false;
          console.error('Failed to update ranking', err);
          alert('Update failed — see console for details.');
        }
      });

      return;
    }

    // CREATE new record
    const postUrl = `${environment.apiUrl}/collegeranking`;

    this.http.post<any>(postUrl, payload, { headers }).subscribe({
      next: res => {
        this.savingRanking = false;
        alert('Ranking saved successfully.');

        // store id for future updates
        if (res && res._id) {
          this.rankingRecordId = res._id;
        }
      },
      error: err => {
        this.savingRanking = false;
        console.error('Failed to save ranking', err);
        alert('Save failed — see console for details.');
      }
    });
  }

  //Scholarship
  loadScholarship(): void {
    var self = this;

    if (!this.collegeId) {
      console.warn('No collegeId in route.');
      return;
    }

    var headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole'),
      }),
    };

    // 1️⃣ FIRST TRY: /collegeinformations?college=<collegeId>
    var url =
      environment.apiUrl +
      '/collegeinformations?college=' +
      encodeURIComponent(this.collegeId);

    this.http.get<any>(url, { headers }).subscribe(
      function (res) {
        var info: any = null;

        // Case A: { results: [ {...} ] }
        if (res && res.results && res.results.length > 0) {
          info = res.results[0];
        }
        // Case B: [ {...} ]
        else if (res && res.length && Array.isArray(res)) {
          info = res[0];
        }
        // Case C: { _id: ..., scholarship: ... }
        else if (res && res._id) {
          info = res;
        }

        if (info && info.scholarship) {
          // ✅ Found scholarship in /collegeinformations
          self.informationId = info._id || '';
          self.scholarshipForm.patchValue({
            scholarship: info.scholarship || ''
          });
          console.log(
            'Loaded scholarship from /collegeinformations. infoId =',
            self.informationId
          );
          return;
        }

        // 2️⃣ FALLBACK: try /college (list) and use top-level "scholarship"
        self.loadScholarshipFromCollege(headers);
      },
      function (err) {
        console.error(
          'Failed to load scholarship from /collegeinformations, trying /college...',
          err
        );
        // fallback on error
        self.loadScholarshipFromCollege(headers);
      }
    );
  }

  // Helper fallback: read scholarship directly from /college JSON
  loadScholarshipFromCollege(headers: any): void {
    var self = this;

    this.http
      .get<any>(environment.apiUrl + '/college', { headers })
      .subscribe(
        function (res) {
          var college: any = null;

          if (res && res.results && res.results.length > 0) {
            college = res.results.find(function (c: any) {
              return c._id === self.collegeId;
            });
          }

          if (!college) {
            console.warn('College not found for id (fallback):', self.collegeId);
            return;
          }

          // 🔹 This is where your example "kjs dns jd..." lives:
          // "scholarship": "kjs dns jd cjns dj jsd j sdj jsnm n sj djfsdf d jh"
          var value =
            (college.scholarship ? college.scholarship : '');

          self.scholarshipForm.patchValue({
            scholarship: value
          });
        },
        function (err) {
          console.error('Failed to load scholarship from /college', err);
        }
      );
  }


  onSaveScholarship(): void {
    this.submittedScholarship = true;

    if (this.scholarshipForm.invalid) {
      return;
    }

    if (!this.collegeId) {
      alert('College id not found.');
      return;
    }

    var scholarshipValue = this.scholarshipForm.value.scholarship;
    var self = this;

    this.savingScholarship = true;

    var headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole'),
      }),
    };

    // ---------- CASE 1: UPDATE via PATCH (record already exists) ----------
    if (this.informationId) {
      var patchUrl =
        environment.apiUrl + '/collegeinformations/' + this.informationId;

      var patchPayload = {
        college: this.collegeId,   // backend requires "college"
        scholarship: scholarshipValue
      };

      this.http.patch<any>(patchUrl, patchPayload, { headers }).subscribe(
        function (res) {
          self.savingScholarship = false;
          alert('Scholarship saved successfully.');
        },
        function (err) {
          self.savingScholarship = false;
          console.error('Failed to update scholarship', err);
          alert('Update failed — see console for details.');
        }
      );

      return;
    }

    // ---------- CASE 2: CREATE via POST (no existing record) ----------
    var postUrl = environment.apiUrl + '/collegeinformations';

    var postPayload = {
      college: this.collegeId,     // required by backend
      scholarship: scholarshipValue
    };

    this.http.post<any>(postUrl, postPayload, { headers }).subscribe(
      function (res) {
        self.savingScholarship = false;
        alert('Scholarship saved successfully.');

        if (res && res._id) {
          self.informationId = res._id;   // so next time we PATCH
        }
      },
      function (err) {
        self.savingScholarship = false;
        console.error('Failed to save scholarship', err);
        alert('Save failed — see console for details.');
      }
    );
  }
  loadApplicationDates(): void {
    var self = this;

    var headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole'),
      }),
    };

    // /college returns list with results[]
    this.http.get<any>(environment.apiUrl + '/college', { headers })
      .subscribe(
        function (res) {
          var college = null;

          if (res && res.results && res.results.length > 0) {
            college = res.results.find(function (c: any) {
              return c._id === self.collegeId;
            });
          }

          if (!college) {
            console.warn('College not found for id:', self.collegeId);
            return;
          }

          self.applicationForm.patchValue({
            application_open: college.application_open || '',
            application_deadline: college.application_deadline || '',
            registration_start: college.registration_start || '',
            registration_deadline: college.registration_deadline || ''
          });
        },
        function (err) {
          console.error('Failed to load colleges', err);
        }
      );
  }
  //Application Form
  onSaveApplication(): void {
    this.submittedApplication = true;

    if (this.applicationForm.invalid) {
      return;
    }

    if (!this.collegeId) {
      alert('College id not found.');
      return;
    }

    var value = this.applicationForm.value;

    // payload only with the 4 date fields
    var payload = {
      application_open: value.application_open,
      application_deadline: value.application_deadline,
      registration_start: value.registration_start,
      registration_deadline: value.registration_deadline
    };

    this.savingApplication = true;

    var headers = {
      Userinfo: JSON.stringify({
        _id: localStorage.getItem('adminSess'),
        role: localStorage.getItem('userRole'),
      }),
    };

    // 🔹 UPDATE the college itself – use PUT, not PATCH
    var url = environment.apiUrl + '/college/' + this.collegeId;

    this.http.put<any>(url, payload, { headers: headers })
      .subscribe(
        res => {
          this.savingApplication = false;
          alert('Application dates saved successfully.');
        },
        err => {
          this.savingApplication = false;
          console.error('Failed to save application dates', err);
          alert('Save failed — check console / Network tab.');
        }
      );
  }

}






